<template>
  <div class="bikelist-container">
    <el-form :model="queryInfo" size="medium" :label-width="formLabelWidth('sm2')">
      <el-row>
        <el-col :span="5" v-if="userinfo.tenantType === 0">
          <el-form-item :label="$t('manage.name86')" prop="tenantIds">
            <el-cascader ref="refHandle" v-model="tenantIds" :placeholder="$t('public.name1')" @change="handleChange" :props="{ lazy: true, lazyLoad: loadOptions }" clearable></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="15">
            <el-form-item :label="$t('bike.name84')" prop="searchTime">
              <el-date-picker
            v-model="searchTime"
            type="datetimerange"
           value-format="yyyy-MM-dd HH:mm:ss"
            :range-separator="$t('public.name9')"
            :start-placeholder="$t('public.name10')"
            :end-placeholder="$t('public.name11')"
          >
          </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" size="medium" @click="getPageList">{{ $t('public.name3') }}</el-button>
          <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-table ref="table"  :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <el-table-column :label="$t('bike.name105')" prop="tenantName" sortable v-if="userinfo.tenantType === 0"></el-table-column>
      <el-table-column :label="$t('bike.name38')" prop="ebikeId" sortable></el-table-column>
      <el-table-column :label="$t('bike.name70')" prop="cycleId" sortable> </el-table-column>
      <el-table-column :label="$t('bike.name485')" prop="distance" sortable></el-table-column>
      <el-table-column :label="$t('bike.name486')" prop="duration" sortable></el-table-column>
      <el-table-column :label="$t('bike.name487')" prop="startTime" sortable>
        <template slot-scope="scope">
          {{ scope.row.startTime | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name488')" prop="endTime" sortable>
        <template slot-scope="scope">
          {{ scope.row.endTime | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name11')" width="140px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="showDetailsDialog(scope.row)">{{ $t('bike.name489') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
     <!--轨迹详情-->
     <AppDialog
       size="lg"
       width="90%"
       extra-class="map-trace-dialog"
       :title="$t('bike.name489')"
       :visible.sync="eBikeDetailsDialog"
       v-if="eBikeDetailsDialog"
       :before-close="close"
       @opened="handleTraceDialogOpened"
     >
      <div class="trace-dialog-content clearfix">
        <div style="margin-bottom: 20px">
            <span>
              <span>{{ $t('operate.name72') }}</span>
              <el-radio v-model="mapchange" label="1" @change="mapchangeradio">{{ $t('operate.name73') }}</el-radio>
              <el-radio v-model="mapchange" label="2" @change="mapchangeradio">{{ $t('operate.name74') }}</el-radio>
            </span>
        </div>
        <div v-if="mapchange==='1'">
          <template>
            <el-form ref="queryForm" :inline="true">
              <el-row>
                <el-col :span="6">
                  <el-form-item :label="$t('operate.name75')">
                    <el-slider v-model="speed" style="width: 200px" :step="1" :min="10"
                               :input="inputspeed(speed)"></el-slider>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item style="float: left">
                    <el-button icon="el-icon-video-play" size="mini" @click="bikePolyLinestart">{{ $t('operate.name76') }}</el-button>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </template>
          <GmapMap :center='markerPoint' :zoom="googleMapZoom" ref="mapRef" class="map" id="mapps">
            <gmap-marker
              @click="bikePolyLine"
              :position="startmarkerPoint"
              :icon="startmarkericon">
            </gmap-marker>
            <gmap-marker
              :position="endmarkerPoint"
              :icon="endmarkericon">
            </gmap-marker>
          </GmapMap>
        </div>
        <div v-else-if="mapchange==='2'">
          <el-form ref="queryForm" :inline="true">
            <el-row>
              <el-col :span="5">
                <el-form-item :label="$t('operate.name75')">
                  <el-slider v-model="speedbaidu" style="width: 200px" :step="1"></el-slider>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item style="float: right">
                  <el-button type="primary" @click="handleQuery">{{ $t('operate.name77') }}</el-button>
                  <el-button type="primary" @click="handPathStop">{{ $t('operate.name78') }}</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <template>
            <baidu-map class="map" :center="markerPointbaidu" :zoom="20" :scroll-wheel-zoom='true'>
              <bm-polyline :path="pathbaidu" stroke-color="#275aff" :stroke-opacity="0.8" :stroke-weight="5"
                           :editing="false"
              ></bm-polyline>
              <bm-marker :position="startmarkerPointbaidu" :icon="startmarkericonbaidu"></bm-marker>
              <bm-marker :position="endmarkerPointbaidu" :icon="endmarkericonbaidu"></bm-marker>
              <bml-lushu
                @stop="reset"
                :speed="speedbaidu*5"
                :path="pathbaidu"
                :icon="icon"
                :play="playbaidu">
              </bml-lushu>
            </baidu-map>
          </template>
        </div>
      </div>
    </AppDialog>
  </div>
</template>
<script>
import { findCyclePage, findCycleTraceList } from '@/api/bike.js'
import { tenantList } from '@/api/manage.js'
import { gmapApi } from 'vue2-google-maps'
import coordtransform from 'coordtransform'
import { BmlLushu } from 'vue-baidu-map'
import { mapGetters } from 'vuex'
import AppDialog from '@/components/AppDialog/index.vue'
import { defaultMapChange } from '@/config/flavor'
import { toMapLngLat, resolveInitialZoom } from '@/utils/mapCoords'
export default {
  data() {
    return {
      searchTime: null,
      tenantIds: [],
      queryInfo: {
        startTime: '',
        endTime: '',
        tenantId: '',
        pageNumber: 1,
        pageSize: 10
      },
      total: 0,
      tableLoading: false,
      tableList: [],
      cycleId: '',
      eBikeDetailsDialog: false,
      // 缺省来自 flavor：海外 google('1') / 国内百度('2')；本页暂无天地图
      mapchange: defaultMapChange,
      center: {
        lng: 0,
        lat: 0
      },
      zoom: 15,
      markerPoint: {
        lng: 0,
        lat: 0
      },
      startmarkerPoint: {
        lng: 0,
        lat: 0
      },
      endmarkerPoint: {
        lng: 0,
        lat: 0
      },
      polylinemaker: {
        strokeColor: '#275aff'
      },
      count: 0,
      count2: 0,
      speed: 0,
      startmarkericon: {
        url: require('@/assets/start.png'),
        size: {
          width: 32,
          height: 32
        },
        scaledSize: {
          width: 32,
          height: 32
        }
      },
      endmarkericon: {
        url: require('@/assets/end.png'),
        size: {
          width: 32,
          height: 32
        },
        scaledSize: {
          width: 32,
          height: 32
        }
      },
      bikemarkericon: {
        url: require('@/assets/bike.png'),
        size: {
          width: 32,
          height: 32
        },
        scaledSize: {
          width: 32,
          height: 32
        }
      },
      formData: [
        {
          // 电机状态 1：正常 0：异常
          motorState: '',
          // 距离
          distance: '',
          // 最低海拔
          minElevation: '',
          cycleId: '',
          ebikeId: '',
          // 持续时间 单位：分钟
          duration: '',
          // 电池状态
          batteryState: '',
          // 落差
          elevationDrop: '',
          // 车辆状态
          bikeState: '',
          // 骑行开始时间 yyyy-MM-dd HH:mm:ss
          startTime: '',
          // 骑行结束时间
          endTime: '',
          // 最小速度
          minSpeed: '',
          // 骑行状态
          cycleStatus: '',
          // 下坡速度
          downslopeSpeed: '',
          // 封面文件名
          picName: '',
          // 骑行名称
          cyclingName: '',
          // 开始坐标
          startLng: '',
          startLat: '',
          // 传感器状态
          sensorState: '',
          // 上坡速度
          upslopeSpeed: '',
          // 最大速度
          maxSpeed: '',
          userId: '',
          // 控制器状态
          controlState: '',
          // 平均速度
          avgSpeed: '',
          createTime: '',
          // 平地速度
          flatslopeSpeed: '',
          // 最高海拔
          maxElevation: ''
        }
      ],
      path: [],
      bikePath: [
        {
          ebikeId: '',
          cycleId: '',
          dataTime: '',
          lng: '',
          lat: '',
          alt: '',
          speed: ''
        }
      ],
      startMark: {},
      bikespeed: 20,
      play: false,
      startMarkerPoint: {
        lng: '',
        lat: ''
      },
      endMarkerPoint: {
        lng: '',
        lat: ''
      },
      // 百度地图
      icon: {
        url: require('@/assets/bike.png'),
        size: {
          width: 32,
          height: 32
        },
        opts: {
          imageSize: {
            width: 32,
            height: 32
          }
        }
      },
      startmarkericonbaidu: {
        url: require('@/assets/start.png'),
        size: {
          width: 32,
          height: 32
        },
        opts: {
          imageSize: {
            width: 32,
            height: 32
          }
        }
      },
      endmarkericonbaidu: {
        url: require('@/assets/end.png'),
        size: {
          width: 32,
          height: 32
        },
        opts: {
          imageSize: {
            width: 32,
            height: 32
          }
        }
      },
      markerPointbaidu: {
        lng: 0,
        lat: 0
      },
      startmarkerPointbaidu: {
        lng: 0,
        lat: 0
      },
      endmarkerPointbaidu: {
        lng: 0,
        lat: 0
      },
      speedbaidu: 10,
      pathbaidu: [],
      playbaidu: false,
      car_animate: null
    }
  },
  components: {
    BmlLushu,
    AppDialog
  },
  created() {
    this.queryList()
  },
  mounted() {},
  computed: {
    google: gmapApi,
    ...mapGetters(['userinfo']),
    googleMapZoom () {
      return resolveInitialZoom(this.path.length) || 18
    }
  },
  methods: {
    getPageList() {
      this.queryInfo.pageNumber = 1
      this.queryInfo.pageSize = 10
      this.queryList()
    },
    buildCycleListParams(pageNumber, pageSize) {
      const params = {
        ...this.queryInfo,
        pageNumber,
        pageSize
      }
      if (this.searchTime) {
        const { startTime, endTime } = this.$tz.rangeToAccountQuery(this.searchTime)
        params.startTime = startTime
        params.endTime = endTime
      }
      return params
    },
    async queryList() {
      this.tableLoading = true
      try {
        const params = this.buildCycleListParams(this.queryInfo.pageNumber, this.queryInfo.pageSize)
        const res = await findCyclePage(params)
        if (res && res.code === 200) {
          this.tableList = (res.data && res.data.cyclePage && res.data.cyclePage.records) || []
          this.total = (res.data && res.data.cyclePage && res.data.cyclePage.total) || 0
        } else {
          this.tableList = []
          this.total = 0
        }
      } catch (e) {
        this.tableList = []
        this.total = 0
      } finally {
        this.tableLoading = false
      }
    },
    getDataList() {
      return this.queryList()
    },
    resetQuery() {
      this.searchTime = null
      this.queryInfo = {
        startTime: '',
        endTime: '',
        tenantId: '',
        pageNumber: 1,
        pageSize: 10
      }
      this.tenantIds = []
      this.queryList()
    },
    showDetailsDialog(row) {
      this.cycleId = row.cycleId
      this.eBikeDetailsDialog = true
      this.getCycleTraceList()
    },
    getCycleTraceList() {
      this.path = []
      this.pathbaidu = []
      const data = {
        cycleId: this.cycleId
      }
      findCycleTraceList(data)
        .then((res) => {
          if (res.code === 200) {
            this.bikePath = res.data.ebikeGisList
            // this.bikePath = [
            //   { ebikeId: 'LS869951036702730', cycleId: '2387af4b60174b9ca6140be6b6c13b6f', dataTime: '2024-12-26 16:21:54', lng: '-86.45560521', lat: '30.39032459', alt: '-26', speed: '0' },
            //   { ebikeId: 'LS869951036702730', cycleId: '2387af4b60174b9ca6140be6b6c13b6f', dataTime: '2024-12-26 16:21:59', lng: '-86.45561065', lat: '30.39035667', alt: '-24', speed: '0' },
            //   { ebikeId: 'LS869951036702730', cycleId: '2387af4b60174b9ca6140be6b6c13b6f', dataTime: '2024-12-26 16:22:17', lng: '-86.45560958', lat: '30.3903672', alt: '-22', speed: '0' },
            //   { ebikeId: 'LS869951036702730', cycleId: '2387af4b60174b9ca6140be6b6c13b6f', dataTime: '2024-12-26 16:22:23', lng: '-86.4556264', lat: '30.39035102', alt: '-22', speed: '26' },
            //   { ebikeId: 'LS869951036702730', cycleId: '2387af4b60174b9ca6140be6b6c13b6f', dataTime: '2024-12-26 16:22:26', lng: '-86.45562082', lat: '30.3903612', alt: '-22', speed: '0' },
            //   { ebikeId: 'LS869951036702730', cycleId: '2387af4b60174b9ca6140be6b6c13b6f', dataTime: '2024-12-26 16:22:29', lng: '-86.45561473', lat: '30.39037734', alt: '-23', speed: '10' },
            //   { ebikeId: 'LS869951036702730', cycleId: '2387af4b60174b9ca6140be6b6c13b6f', dataTime: '2024-12-26 16:22:44', lng: '-86.4556081', lat: '30.39036415', alt: '-22', speed: '20' },
            //   { ebikeId: 'LS869951036702730', cycleId: '2387af4b60174b9ca6140be6b6c13b6f', dataTime: '2024-12-26 16:40:34', lng: '-86.45948301', lat: '30.38855628', alt: '-30', speed: '0' },
            //   { ebikeId: 'LS869951036702730', cycleId: '2387af4b60174b9ca6140be6b6c13b6f', dataTime: '2024-12-26 16:40:39', lng: '-86.45952124', lat: '30.3885871', alt: '-34', speed: '0' },
            //   { ebikeId: 'LS869951036702730', cycleId: '2387af4b60174b9ca6140be6b6c13b6f', dataTime: '2024-12-26 16:40:42', lng: '-86.45967926', lat: '30.38866939', alt: '-61', speed: '0' },
            //   { ebikeId: 'LS869951036702730', cycleId: '2387af4b60174b9ca6140be6b6c13b6f', dataTime: '2024-12-26 16:40:44', lng: '-86.45966498', lat: '30.38866319', alt: '-60', speed: '0' },
            //   { ebikeId: 'LS869951036702730', cycleId: '2387af4b60174b9ca6140be6b6c13b6f', dataTime: '2024-12-26 17:28:59', lng: '-86.46067345', lat: '30.38674741', alt: '-41', speed: '120' }
            // ]
            if (this.bikePath.length !== 0) {
              if (this.mapchange === '1') {
                this.bikePath.forEach((item) => {
                  const pt = toMapLngLat(Number(item.lng), Number(item.lat), 'google')
                  if (pt) {
                    this.path.push({ lng: pt.lng, lat: pt.lat })
                  }
                })
                this.markerPoint.lng = this.path[0].lng
                this.markerPoint.lat = this.path[0].lat
                this.startmarkerPoint.lng = this.path[0].lng
                this.startmarkerPoint.lat = this.path[0].lat
                this.endmarkerPoint.lng = this.path[this.path.length - 1].lng
                this.endmarkerPoint.lat = this.path[this.path.length - 1].lat
                setTimeout(() => {
                  this.bikePolyLine()
                }, 100)
              } else if (this.mapchange === '2') {
                this.bikePath.forEach((item) => {
                  const bikepoints = coordtransform.wgs84togcj02(item.lng, item.lat)
                  const bikepointss = coordtransform.gcj02tobd09(bikepoints[0], bikepoints[1])
                  this.pathbaidu.push({
                    lng: Number(bikepointss[0]),
                    lat: Number(bikepointss[1])
                  })
                })
                this.markerPointbaidu.lng = this.pathbaidu[0].lng
                this.markerPointbaidu.lat = this.pathbaidu[0].lat
                this.startmarkerPointbaidu.lng = this.pathbaidu[0].lng
                this.startmarkerPointbaidu.lat = this.pathbaidu[0].lat
                this.endmarkerPointbaidu.lng = this.pathbaidu[this.pathbaidu.length - 1].lng
                this.endmarkerPointbaidu.lat = this.pathbaidu[this.pathbaidu.length - 1].lat
              }
            }
          }
        })
        .catch(() => {})
    },
    close() {
      this.eBikeDetailsDialog = false
    },
    handleTraceDialogOpened() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.resizeTraceMap()
          if (this.bikePath.length !== 0) {
            if (this.mapchange === '1') {
              this.bikePolyLine()
            } else if (this.mapchange === '2') {
              this.playbaidu = true
            }
          }
        }, 150)
      })
    },
    resizeTraceMap() {
      if (this.mapchange === '1' && this.$refs.mapRef) {
        this.$refs.mapRef.$mapPromise.then((map) => {
          if (this.google && this.google.maps) {
            this.google.maps.event.trigger(map, 'resize')
            if (this.markerPoint.lng) {
              map.setCenter(this.markerPoint)
            }
          }
        }).catch(() => {})
      }
    },
    inputspeed (speed) {
      this.speed = speed
    },
    mapchangeradio() {
      this.getCycleTraceList()
    },
    bikePolyLine () {
      var lineSymbol = {
        path: this.google.maps.SymbolPath.FORWARD_OPEN_ARROW,
        fillColor: '#FFF',
        strokeColor: '#FFF',
        scale: 0.9,
        strokeWeight: 3,
        fillOpacity: 0.8
      }
      this.stratbikemaker()
      this.$refs.mapRef.$mapPromise.then((map) => {
        this.flightPath = new this.google.maps.Polyline({
          path: this.path,
          strokeColor: '#275aff',
          icons: [{
            icon: lineSymbol,
            offset: '0',
            repeat: '5%'
          }],
          strokeOpacity: 0.8,
          strokeWeight: 10
        })
        this.flightPath.setMap(map)
      })
    },
    bikePolyLinestart () {
      clearInterval(this.car_animate)
      this.car_animate = setInterval(() => {
        this.markerBlack.setIcon(this.bikemarkericon)
        this.markerBlack.setPosition(this.path[this.count])
        this.count += 1
        this.count2 = this.count
        if (this.count === this.path.length) {
          this.markerBlack.setPosition(this.path[this.path.length - 1])
          this.count2 = 0
          this.count = 0
          clearInterval(this.car_animate)
        }
      }, (1 / this.speed) * 7000)
    },
    reset () {
      this.playbaidu = false
    },
    loadOptions(node, resolve) {
      if (node.level === 2) {
        resolve([])
        return
      }
      let data = {
        page: 1,
        limit: 500,
        tenantType: 1
      }

      if (node.level === 1) {
        data = {
          page: 1,
          limit: 500,
          tenantType: 2,
          parentId: node.value
        }
      }

      tenantList(data)
        .then(res => {
          if (res.data.list) {
            const options = res.data.list.map(item => ({
              value: item.tenantId,
              label: item.tenantName,
              leaf: node.level >= 1
            }))
            resolve(options)
          } else {
            resolve([])
          }
        })
        .catch(() => {})
    },
    handleChange(value) {
      // 处理选项变化
      this.queryInfo.tenantId = value[value.length - 1]
      const panelRefs = this.$refs.refHandle.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.activePath.forEach(item => {
          if (item.children.length === 0) {
            panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
          }
        })
      }
    },
    handleQuery () {
      this.playbaidu = true
    },
    handPathStop () {
      this.playbaidu = false
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.queryInfo.pageNumber = 1
      this.queryList()
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNumber = newPage
      this.queryList()
    }
  }
}
</script>

<style lang="scss" scoped>
.bikelist-container {
  display: flex;
  flex-direction: column;

  .trace-dialog-content {
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
  }

  .top{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .title-style{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title{
      width: 50%;
      text-align: center;
    }
  }

  .date-picker{
    display: flex;
    flex-direction: row;
   .search-bt{
      margin-left: 25px;
    }
  }

  .file-list{
    width: 70%;
    display: flex;
    justify-content: space-between;
    margin-top: -25px;

    .el-icon-close{
      font-size: 18px;
    }
  }

  .green {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #ebf6ed;
    color: #39ab4c;
  }

  .red {
    width: 54px;
    height: 24px;
    text-align: center;
    border-radius: 2px;
    background: #fcecec;
    color: #ea4646;
  }
  .map {
    width: 100%;
    height: 800px;
  }
}
</style>
